import { Injectable, signal } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class LoadingOverlayService {
  private counter = 0;

  readonly visible = signal(false);

  show(): void {
    this.counter++;
    this.visible.set(true);
  }

  hide(): void {
    if (this.counter > 0) {
      this.counter--;
    }

    if (this.counter === 0) {
      this.visible.set(false);
    }
  }

  reset(): void {
    this.counter = 0;
    this.visible.set(false);
  }
}